import { useEffect, useState } from 'react';
import { buildApiUrl } from '../../common/api';

/**
 * Form indirizzo con geocoding Nominatim (via backend).
 */
export default function IndirizzoForm({ value, onChange, className = '' }) {
  const [query, setQuery] = useState('');
  const [suggerimenti, setSuggerimenti] = useState([]);
  const [geoMsg, setGeoMsg] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (query.length < 4) {
      setSuggerimenti([]);
      return;
    }
    const t = setTimeout(() => {
      fetch(buildApiUrl(`/api/catalogo/indirizzi?q=${encodeURIComponent(query)}`))
        .then((r) => r.json())
        .then((j) => setSuggerimenti(j.risultati || []))
        .catch(() => setSuggerimenti([]));
    }, 400);
    return () => clearTimeout(t);
  }, [query]);

  const setField = (field, val) => onChange({ ...value, [field]: val });

  const applicaSuggerimento = (s) => {
    onChange({
      via: s.via || s.label.split(',')[0] || '',
      citta: s.citta || '',
      cap: s.cap || '',
      lat: s.lat,
      lng: s.lng,
    });
    setQuery('');
    setSuggerimenti([]);
    setGeoMsg('Indirizzo verificato');
  };

  const verificaIndirizzo = async () => {
    setLoading(true);
    setGeoMsg('');
    try {
      const res = await fetch(buildApiUrl('/api/catalogo/geocode'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ via: value.via, citta: value.citta, cap: value.cap }),
      });
      const j = await res.json();
      if (j.coordinates) {
        onChange({ ...value, lat: j.coordinates.lat, lng: j.coordinates.lng });
        setGeoMsg('Coordinate aggiornate');
      } else {
        setGeoMsg('Indirizzo non geolocalizzato — verifica via e città');
      }
    } catch {
      setGeoMsg('Errore verifica indirizzo');
    } finally {
      setLoading(false);
    }
  };

  const geolocate = () => {
    navigator.geolocation?.getCurrentPosition((pos) => {
      onChange({ ...value, lat: pos.coords.latitude, lng: pos.coords.longitude });
      setGeoMsg('Posizione GPS acquisita');
    });
  };

  return (
    <div className={`space-y-3 ${className}`}>
      <div className="relative">
        <label className="block text-sm font-medium mb-1">Cerca indirizzo</label>
        <input
          type="search"
          className="w-full border rounded-xl px-4 py-2.5 text-sm"
          placeholder="Via, città… (min 4 caratteri)"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        {suggerimenti.length > 0 && (
          <ul className="absolute z-20 w-full bg-white border rounded-xl shadow-lg mt-1 max-h-48 overflow-auto text-sm">
            {suggerimenti.map((s, i) => (
              <li key={i}>
                <button type="button" className="w-full text-left px-3 py-2 hover:bg-gray-50"
                  onClick={() => applicaSuggerimento(s)}>
                  {s.label}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="sm:col-span-2">
          <label className="block text-sm font-medium mb-1">Via *</label>
          <input required className="w-full border rounded-xl px-4 py-2.5 text-sm" value={value.via || ''}
            onChange={(e) => setField('via', e.target.value)} />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">CAP *</label>
          <input required className="w-full border rounded-xl px-4 py-2.5 text-sm" value={value.cap || ''}
            onChange={(e) => setField('cap', e.target.value)} />
        </div>
        <div className="sm:col-span-3">
          <label className="block text-sm font-medium mb-1">Città *</label>
          <input required className="w-full border rounded-xl px-4 py-2.5 text-sm" value={value.citta || ''}
            onChange={(e) => setField('citta', e.target.value)} />
        </div>
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <button type="button" onClick={verificaIndirizzo} disabled={loading || !value.via || !value.citta}
          className="text-sm border border-[#c78244] text-[#c78244] rounded-lg px-3 py-1.5 disabled:opacity-50">
          {loading ? 'Verifica…' : 'Verifica indirizzo'}
        </button>
        <button type="button" onClick={geolocate} className="text-sm border border-gray-300 rounded-lg px-3 py-1.5">
          📍 GPS
        </button>
        {value.lat && value.lng && (
          <span className="text-xs text-green-700">Geo OK ({Number(value.lat).toFixed(3)}, {Number(value.lng).toFixed(3)})</span>
        )}
        {geoMsg && <span className="text-xs text-gray-500">{geoMsg}</span>}
      </div>
    </div>
  );
}
